import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { ColumnComponent } from './column/column.component';
import { SortInterface } from '../../sort-control/sort.interface';
import { PaginationInterface } from '../../../../core/config/pagination.interface';

@Component({
  selector: 'app-sortable-table',
  templateUrl: './sortable-table.component.html',
  styleUrls: ['./sortable-table.component.css']
})
export class SortableTableComponent implements OnChanges {
  @Input() elements: any[];
  @Input() mainColumnIndex = 0;
  @Input() selectedOrder: SortInterface;
  @Input() paginationConfig: PaginationInterface;
  @Input() rowClass: (value: any) => string = null;
  @Output() sort = new EventEmitter<SortInterface>();
  @ContentChildren(ColumnComponent) columns: QueryList<ColumnComponent>;
  @ViewChild(PerfectScrollbarDirective) content: PerfectScrollbarDirective;
  paginationConfiguration: PaginationInterface;

  ngOnChanges(_changes: SimpleChanges) {
    const totalItems = this.elements ? this.elements.length : 0;
    this.paginationConfiguration = this.paginationConfig ?
    this.paginationConfig : { itemsPerPage: totalItems, currentPage: 1, totalItems: totalItems };
  }

  getRowClass(row: any) {
    return (this.rowClass) ? this.rowClass(row) : '';
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/tables/sortable-table/sortable-table.component.ts